import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const L14B = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  ${customTextColor}
`;
